"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";

export default function LegalNoticePage() {
  const t = useTranslations("legal.notice");
  const { locale } = useParams();

  const companyBulletPoints = t.raw("company.bulletPoints") as string[];
  const companyAdditionalInfo = t.raw("company.additionalInfo") as string[];
  const hostingDetails = t.raw("company.hosting.details") as string[];
  const rgpdBulletPoints = t.raw("rgpd.bulletPoints") as string[];
  const rgpdRights = t.raw("rgpd.rights") as string[];
  const intellectualBulletPoints = t.raw(
    "intellectual.bulletPoints",
  ) as string[];
  const termsBulletPoints = t.raw("terms.bulletPoints") as string[];

  return (
    <main className="flex min-h-screen max-w-[100vw] flex-col bg-backgroundSecondary">
      <BannerSection title={t("title")} />
      <BreadcrumbHomepage url={`/${locale}`} />
      <div className="container mx-auto px-4 py-16 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <h1 className="mb-8 text-4xl font-bold">{t("title")}</h1>

        <div className="prose prose-invert max-w-none space-y-12">
          {/* Informations sur l'éditeur */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">
              {t("company.title")}
            </h2>
            <p className="mb-4">{t("company.content")}</p>
            <ul className="mb-4 list-inside list-disc space-y-2">
              {companyBulletPoints.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            {companyAdditionalInfo.map((info, index) => (
              <p key={index} className="mb-2">
                {info}
              </p>
            ))}
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">
              {t("company.hosting.title")}
            </h2>
            <p className="mb-4">{t("company.hosting.content")}</p>
            <ul className="mb-4 list-inside list-disc space-y-2">
              {hostingDetails.map((detail, index) => (
                <li key={index}>{detail}</li>
              ))}
            </ul>
          </section>

          {/* Protection des données */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">{t("rgpd.title")}</h2>
            <p className="mb-4">{t("rgpd.content")}</p>
            <ul className="mb-4 list-inside list-disc space-y-2">
              {rgpdBulletPoints.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p className="mb-4">{t("rgpd.legalNotice")}</p>
            <ul className="mb-4 list-inside list-disc space-y-2">
              {rgpdRights.map((right, index) => (
                <li key={index}>{right}</li>
              ))}
            </ul>
            <p>{t("rgpd.cookies")}</p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">
              {t("intellectual.title")}
            </h2>
            <p className="mb-4">{t("intellectual.content")}</p>
            <ul className="list-inside list-disc space-y-2">
              {intellectualBulletPoints.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* CGU */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">{t("terms.title")}</h2>
            <p className="mb-4">{t("terms.content")}</p>
            <ul className="mb-4 list-inside list-disc space-y-2">
              {termsBulletPoints.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t("terms.responsibility")}</p>
          </section>

          {/* Acceptation */}
          <section>
            <h2 className="mb-4 text-2xl font-semibold">
              {t("acceptance.title")}
            </h2>
            <p>{t("acceptance.content")}</p>
          </section>
        </div>
      </div>
    </main>
  );
}
